import React from 'react';
import { Field, ErrorMessage } from 'formik';

/**
 * Reusable SelectField Component
 * 
 * @param {string} name - Field name for Formik
 * @param {string} label - Display label
 * @param {Array} options - Array of {key?, value, label} objects
 * @param {string} placeholder - Placeholder text (default: "Select...")
 * @param {boolean} required - Whether field is required (default: true)
 * @param {string} colSize - Bootstrap column class (default: "col-md-6")
 * @param {Function} onChange - Custom onChange handler
 * @param {boolean} loading - Whether to show loading state
 * @param {boolean} disabled - Whether field is disabled
 * @param {string} className - Additional CSS classes
 */
const SelectField = ({ 
  name, 
  label, 
  options = [], 
  placeholder = "Select...",
  required = true,
  colSize = "col-md-6",
  onChange,
  loading = false,
  disabled = false,
  className = "",
  ...props 
}) => {
  return (
    <div className={`${colSize} mt-3 ${className}`}>
      <div className="form-group">
        <label htmlFor={name} className="form-label">
          {required && <span style={{ color: "red", fontSize: "20px" }}>*</span>}
          {label}
        </label>
        <Field 
          as="select" 
          id={name}
          name={name} 
          className="form-control input-width select"
          {...(onChange !== undefined && { onChange })}
          disabled={disabled || loading}
          {...props}
        >
          <option disabled hidden value="">
            {loading ? "Loading..." : placeholder}
          </option>
          {!loading && options.map(option => (
            <option 
              key={option.key || option.value} 
              value={option.value}
            >
              {option.label}
            </option>
          ))}
        </Field>
        <ErrorMessage name={name} component="div" className="text-danger" />
      </div>
    </div>
  );
};

export default SelectField;